export default "<p>\n  Gerolamo Rovetta (1851 - 1910) è stato uno scrittore e drammaturgo italiano.\n</p>\n";